import { VariantProps, cva } from 'class-variance-authority'

export const selectVariants = cva(
  `ui-flex ui-w-full ui-items-center ui-justify-between ui-rounded-md ui-border ui-border-gray-200 ui-bg-background ui-px-3 ui-py-2 ui-text-sm ui-ring-offset-background placeholder:ui-text-muted-foreground focus:ui-outline-none focus:ui-ring-1 focus:ui-ring-ring focus:ui-ring-offset-1 disabled:ui-cursor-not-allowed disabled:ui-opacity-50 [&>span]:ui-line-clamp-1`,
  {
    variants: {
      size: {
        sm: `ui-h-8 ui-text-xs`,
        md: `ui-h-10 ui-text-sm`,
        lg: `ui-h-12 ui-text-lg`
      }
    },
    defaultVariants: {
      size: `md`
    }
  }
)

export type SelectVariants = VariantProps<typeof selectVariants>
